import "./style.scss";
import "./style-mob.scss";
import { Link } from "react-router-dom";
import Univlogo from "@/src/assets/HomePage/DigitalUniversity/uviv-logo.png";
import { DigitalUniversityApple } from "@/src/svg/DigitalUniversityApple";
import { DigitalUniversityPlay } from "@/src/svg/DigitalUniversityPlay";
import ReadMoreBtn from "@/src/components/ReadMoreBtn/ReadMoreBtn";
import DigitalUniversityAnimation from "./DigitalUniversityAnimation/DigitalUniversityAnimation";

const DigitalUniversity = () => {
  return (
    <div className="digital-university section-margin-top container">
      <div className="digital-university-info">
        <div className="digital-university-info-header">
          <span className="digital-university-info-header-text one">the</span>
          <span className="digital-university-info-header-text two">first</span>
          <span className="digital-university-info-header-text three">digital</span>
          <span className="digital-university-info-header-text four">university</span>
          <span className="digital-university-info-header-text five">in the world</span>
        </div>
        <div className="digital-university-info-description">
          <p>
            <strong>Malta School of medicine & business</strong> is a dynamic and innovative university dedicated to providing
            professional degree courses to students from all over the world. Our mission is to unite a diverse and inclusive community of
            learners, researchers, and professionals to develop the world around us.
          </p>
          <p>
            Students from all over the world. Our mission is to unite a diverse and inclusive community of learners, researchers, and
            professionals to develop the world around us.
          </p>
        </div>
        <div className="digital-university-info-btns">
          <Link to="#" className="digital-university-info-btns-univ">
            <img src={Univlogo} alt="univ-logo" />
          </Link>
          <Link to="#" className="digital-university-info-btns-download apple">
            <DigitalUniversityApple />
            <span>App Store</span>
          </Link>
          <Link to="#" className="digital-university-info-btns-download google">
            <DigitalUniversityPlay />
            <span>google play</span>
          </Link>
        </div>
        <ReadMoreBtn text="Read More →" link="#" className="digital-university-info-read-more-btn" />
      </div>
      <DigitalUniversityAnimation />
    </div>
  );
};

export default DigitalUniversity;
